/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEmployeeDataLeavePolicy
 */
export interface UpdateEmployeeDataLeavePolicy {
    /**
     * A leave policy to define when and how the employee can take leave. Note: changing this value to an employee with an existing leave policy may result in leave periods being regenerated when the new policy results in a different start date.
     * @type {number}
     * @memberof UpdateEmployeeDataLeavePolicy
     */
    id: number | null;
    /**
     * If the policy id changes, move leave requests for the default leave type of the old policy to the default type of the new policy, for the current and future periods. Defaults to false.
     * @type {boolean}
     * @memberof UpdateEmployeeDataLeavePolicy
     */
    migrateToNewDefaultType?: boolean;
}

/**
 * Check if a given object implements the UpdateEmployeeDataLeavePolicy interface.
 */
export function instanceOfUpdateEmployeeDataLeavePolicy(value: object): value is UpdateEmployeeDataLeavePolicy {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateEmployeeDataLeavePolicyFromJSON(json: any): UpdateEmployeeDataLeavePolicy {
    return UpdateEmployeeDataLeavePolicyFromJSONTyped(json, false);
}

export function UpdateEmployeeDataLeavePolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmployeeDataLeavePolicy {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'migrateToNewDefaultType': json['migrateToNewDefaultType'] == null ? undefined : json['migrateToNewDefaultType'],
    };
}

  export function UpdateEmployeeDataLeavePolicyToJSON(json: any): UpdateEmployeeDataLeavePolicy {
      return UpdateEmployeeDataLeavePolicyToJSONTyped(json, false);
  }

  export function UpdateEmployeeDataLeavePolicyToJSONTyped(value?: UpdateEmployeeDataLeavePolicy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'migrateToNewDefaultType': value['migrateToNewDefaultType'],
    };
}

